import { useCallback, useMemo, useState } from 'react';

type SmartButtonConfigPanel = {
	smartButtonActiveNodeLocalId: string | null;
	openSmartButtonConfigPanel: (localId: string) => void;
	closeSmartButtonConfigPanel: (localId?: string) => void;
};

// Hook to maintain state of the active button and provide functions to open/close it. This is used in Confluence's editor integration.
export const useSmartButtonConfigPanel = (): SmartButtonConfigPanel => {
	const [smartButtonActiveNodeLocalId, setSmartButtonActiveNodeLocalId] = useState<string | null>(
		null,
	);

	const openSmartButtonConfigPanel = useCallback(
		(localId: string) => {
			setSmartButtonActiveNodeLocalId(localId);
		},
		[setSmartButtonActiveNodeLocalId],
	);

	const closeSmartButtonConfigPanel = useCallback(() => {
		setSmartButtonActiveNodeLocalId(null);
	}, [setSmartButtonActiveNodeLocalId]);

	return useMemo(
		() => ({
			smartButtonActiveNodeLocalId,
			openSmartButtonConfigPanel,
			closeSmartButtonConfigPanel,
		}),
		[smartButtonActiveNodeLocalId, openSmartButtonConfigPanel, closeSmartButtonConfigPanel],
	);
};
